// /pages/admin/UserSales.js
import React, { useState, useEffect } from 'react';
import axiosInstance from '../../AxiosInstance';
import { Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination } from '@mui/material';

const UserSales = () => {
  const [sales, setSales] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Helper function to format product display
  const formatProductDisplay = (sale) => {
    let display = sale.product_name || '';
    if (sale.variety) {
      display += ` - ${sale.variety}`;
    }
    if (sale.brand) {
      display += ` (${sale.brand})`;
    }
    if (sale.size) {
      display += ` [${sale.size}]`;
    }
    return display;
  };

  useEffect(() => {
    fetchAllSales();
  }, []);

  const fetchAllSales = async () => {
    try {
      const response = await axiosInstance.get('/admin/users/sales'); // Fetch all sales
      console.log(response);
      setSales(response.data.data);
    } catch (error) {
      console.error('Error fetching all sales:', error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Paper sx={{ padding: 2 }}>
      <Typography variant="h4" gutterBottom>All User Sales</Typography>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>User Name</TableCell>
              <TableCell>Shop Name</TableCell>
              <TableCell>Product Name</TableCell>
              <TableCell>Quantity</TableCell>
              <TableCell>Retail Price</TableCell>
              <TableCell>Sale Date</TableCell>
              <TableCell>Unit Type</TableCell>
              <TableCell>Transaction ID</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sales.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((sale) => (
              <TableRow key={sale.sale_id}>
                <TableCell>{sale.username}</TableCell>
                <TableCell>{sale.shop_name}</TableCell>
                <TableCell>{formatProductDisplay(sale)}</TableCell>
                <TableCell>{sale.quantity}</TableCell>
                <TableCell>{sale.retail_price}</TableCell>
                <TableCell>{new Date(sale.sale_date).toLocaleDateString()}</TableCell>
                <TableCell>{sale.unit_type}</TableCell>
                <TableCell>{sale.trans_id || 'N/A'}</TableCell>
              </TableRow>
            ))}
            {sales.length === 0 && (
              <TableRow>
                <TableCell colSpan={8} align="center">No sales data available</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={sales.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25]}
      />
    </Paper>
  );
};

export default UserSales;